import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

interface DeleteConfirmDialogProps {
  open: boolean
  title?: string
  message?: string
  itemName?: string
  dependencies?: string[]
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const DeleteConfirmDialog = ({
  open,
  title = 'Confirm Deletion',
  message = 'Are you sure you want to delete',
  itemName,
  dependencies,
  onClose,
  onConfirm,
  loading = false,
}: DeleteConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>
          {message} {itemName && <strong>{itemName}</strong>}?
        </Typography>
        {dependencies && dependencies.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <Typography variant='subtitle2' color='error'>
              Warning: This item is used by:
            </Typography>
            <Box component='ul' sx={{ mt: 1, pl: 2 }}>
              {dependencies.map((dep, index) => (
                <Typography component='li' key={index} variant='body2'>
                  {dep}
                </Typography>
              ))}
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color='error' variant='contained' disabled={loading}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
